import React, { useContext, useEffect, useState } from "react";
import { useRouterParams } from "../../../abstracts";
import {
  FieldInput,
  ManageMapperLayout,
  FieldDropSide,
  SearchableList,
  LoaderWrapper,
  AddToolTip,
  FormControlSearch,
} from "../../../components";
import { Form, Button, Col, InputGroup } from "react-bootstrap";
import { Field, Formik, ErrorMessage } from "formik";
import { Card } from "react-bootstrap";
import {
  manageMapperStore,
  setFileUploadData,
  setManageMapperToastInfo,
} from "../../../contexts";
import { get, isEmpty } from "lodash-es";
import {
  getPathWithParam,
  MANAGE_MAPPER_ROUTES,
  manageMapperFormNames,
  mapperFormFields,
  FLOW_TYPES,
  ROUTES,
  required,
} from "../../../utils";
import * as Yup from "yup";
import {
  onSavePreview,
  passthroughSaveBasicInformation,
} from "./../../../services/mapper/index";
const initialValues = {};

const typeOptionsForDataModel = [
  { value: 3, label: "Payroll and Census" },
  { value: 1, label: "Payroll" },
  { value: 2, label: "Census" },
];

const typeOptionsForProfileLevel = [
  { value: 1, label: "Plan Level" },
  { value: 2, label: "Global" },
  { value: 3, label: "Plan Group" },
];

const PreviewContainer = (props) => {
  const { flow, profileId, mapType } = useRouterParams();
  const { state, dispatch } = useContext(manageMapperStore);
  const [dataLoading, setDataLoading] = useState(false);
  const isEdit = flow === FLOW_TYPES.EDIT || profileId;
  const formName = manageMapperFormNames.BASIC_INFORMATION;
  const fields = mapperFormFields[formName];
  const data = !isEmpty(
    get(state, "api.fileuploadData.mappingConfiguration", {})
  )
    ? get(state, "api.fileuploadData.mappingConfiguration", {})
    : get(state, "api.data", {});
  const apiOutput = get(data, "isOutput", false);
  const planProfiles = get(state, "api.data.planProfiles", []);
  const headerMapJson = get(data, "headerMapJson", null);
  const fieldHeadersJson = JSON.parse(headerMapJson);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState();
  useEffect(() => {
    setFilteredData(fieldHeadersJson);
  }, [headerMapJson]);

  const ValidationSchema = Yup.object().shape({
    name: Yup.string()
      .required("Required : Map Name")
      .max(150, "Map name should not exceed above 150 characters"),
    mapType: Yup.string().required("Required"),
  });
  const buttons = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      link: ROUTES.MAPPER_HOME,
    },
    {
      label: "Next",
      variant: "primary",
      type: "submit",
      disabled: fieldHeadersJson == null ? true : false,
    },
  ];

  const handleSearch = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
    const filteredResults = fieldHeadersJson.filter((item) =>
      item.fieldName.substring(1).toLowerCase().includes(query.toLowerCase())
    );
    setFilteredData(filteredResults);
  };

  function mergeArraysByProperty(array1, array2, property) {
    // Create a map to store objects by their "id" as the key
    const idMap = new Map();

    // Add objects from array1 to the map
    for (const obj1 of array1) {
      idMap.set(obj1[property], obj1);
    }

    // Add objects from array2, overwriting any existing objects with the same "id"
    for (const obj2 of array2) {
      idMap.set(obj2[property], obj2);
    }

    // Convert the map values back to an array
    const mergedArray = Array.from(idMap.values());

    return mergedArray;
  }

  const onFormSubmit = (values) => {
    setDataLoading(true);
    const { history } = props;
    const combinedArray = mergeArraysByProperty(
      fieldHeadersJson,
      filteredData,
      "order"
    );
    const headerMapJson = JSON.stringify(combinedArray);
    const payload = {
      profileId: profileId,
      step: data.step,
      headerMapJson: headerMapJson,
    };
    onSavePreview(payload)
      .then((response) => {
        setDataLoading(false);
        dispatch(
          setFileUploadData({
            mappingConfiguration: response,
          })
        );
        dispatch(
          setManageMapperToastInfo({
            showToast: true,
            toastMessage: "Data saved successfully",
          })
        );
        history.push(
          getPathWithParam({
            path: MANAGE_MAPPER_ROUTES.PASSTHROUGH_TARGET,
            pathParam: [flow, values[fields.mapType], profileId],
          })
        );
      })
      .catch((e) => {
        setDataLoading(false);
      });
  };

  const previewDataType = [
    { label: "String", value: 1 },
    { label: "Integer", value: 2 },
    { label: "Date", value: 4 },
  ];

  return (
    <Formik
      initialValues={{
        ...initialValues,
        [fields.mapName]: get(data, "name", ""),
        [fields.dataModel]: get(data, "dataModel", 3),
        [fields.profileLevel]: get(data, "profileLevel", 1),
        [fields.mapType]:
          data?.mapType == 1 && apiOutput ? 2 : get(data, "mapType") || 1,
      }}
      enableReinitialize
      onSubmit={onFormSubmit}
      validationSchema={ValidationSchema}
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({
        errors,
        values,
        touched,
        setValues,
        handleChange,
        setFieldValue,
        handleSubmit,
      }) => {
        return (
          <Form
            autoComplete="off"
            className="h-100"
            onSubmit={handleSubmit}
            validated={!isEmpty(errors)}
          >
            <ManageMapperLayout buttons={buttons} planProfiles={planProfiles}>
              <LoaderWrapper isLoading={dataLoading}>
                {filteredData == null ? (
                  <div>No Data Found in the File</div>
                ) : (
                  <div className="preview-outer-layout">
                    <div className="preview-border">
                      <div className="preview-header">
                        <div className="preview-text">
                          <p className="preview-text-style mb-0">Preview</p>
                          <p className="records-found mb-0">
                            {filteredData?.length} records
                          </p>
                        </div>
                        <div className="preview-line"></div>
                        <div className="preview-search">Search</div>
                        <InputGroup className="mb-2 cross-override-close-preview">
                          <InputGroup.Prepend>
                            <div className="passthrough-search-icon-postion">
                              <i class="fal fa-search" aria-hidden="true"></i>
                            </div>
                          </InputGroup.Prepend>
                          <FormControlSearch
                            screen={"plan-group-home"}
                            size="sm"
                            id="source-search-box"
                            type="text"
                            className="source-search-box-var cross-override-close pl-5 w-70 mr-0"
                            placeholder={
                              mapType == 3
                                ? "Search"
                                : "Search source fields here"
                            }
                            onChange={handleSearch}
                            autoComplete="off"
                            onKeyPress={(e) => {
                              e.key === "Enter" && handleChange(e);
                            }}
                          />
                        </InputGroup>
                        <div className="mappercard-outer">
                          {filteredData?.map((item, index) => (
                            <div className="preview-mappercard">
                              <div className="d-flex align-content-center justify-content-center preview-wrap preview-wrap-index grey-text">
                                {index + 1}
                              </div>
                              <div className="mt-2 mb-2 d-flex preview-wrap preview-wrap-name">
                                <div className="h-50 w-100 preview-name">
                                  <AddToolTip
                                    name={item.fieldName.substring(1)}
                                  >
                                    {item.fieldName.length >= 20
                                      ? `${item.fieldName.slice(1, 20)}...`
                                      : item.fieldName.substring(1)}
                                  </AddToolTip>
                                </div>
                                <div className="h-50 w-100 preview-name-datum d-flex align-items-end">
                                  <AddToolTip name={item.datum}>
                                    {item.datum.length >= 20
                                      ? `${item.datum.slice(0, 20)}...`
                                      : item.datum}
                                  </AddToolTip>
                                </div>
                              </div>
                              <div className="d-flex align-content-center justify-content-center preview-wrap preview-wrap-datatype">
                                <Field
                                  size="sm"
                                  name={`dataType${item.order}`}
                                  value={
                                    values[`dataType${item.order}`] ?? item.type
                                  }
                                  options={previewDataType}
                                  direction="bottom"
                                  popupContent={
                                    <SearchableList
                                      isNotTypeAhead
                                      label="Select Data Type"
                                      options={previewDataType}
                                      onSelect={(value) => {
                                        item.type = value;
                                        setFieldValue(
                                          `dataType${item.order}`,
                                          value
                                        );
                                      }}
                                      selectedValue={
                                        values[`dataType${item.order}`]
                                      }
                                    />
                                  }
                                  component={FieldDropSide}
                                />
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </LoaderWrapper>
            </ManageMapperLayout>
          </Form>
        );
      }}
    </Formik>
  );
};

export default PreviewContainer;
